import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import './login.css';
import PicLogin from '../../images/cleanWorld.jpg';
import jwt_decode from 'jwt-decode'




const Login = () => {

    const [user, setUser] = useState({
        password: '',
        mail: ''
    })
    let history = useHistory()

    const queryData = (e) => {
        e.preventDefault()
        axios.post(`https://clean-my-calanques.herokuapp.com/LoginRoute/login`, user)
            .then(res => {
                localStorage.setItem('userToken', res.data)
                return res.data
            })
            .then(res => {
                history.push('/monProfil')
            })
    }


    const redirect = () => {
        history.push('/register')
    }

    return (
        <div className="containerLogin">



            <img  className="picLogin" src={PicLogin} alt="picLogin"></img>
            <div className="contain">
            <h1 className="titleLogin">Se connecter</h1>

        <form onSubmit={queryData}>
            <input className="at" placeholder="E-mail" name='mail' value={user.mail} required type='text' onChange={(e) => setUser({ ...user, mail: e.target.value })} />
            <input className="lock" placeholder="Mot de passe" name='password' value={user.password} required type='password' onChange={(e) => setUser({ ...user, password: e.target.value })} />

            <button className='btnLogin' type='submit'>
                Se connecter
                </button>
        </form>

        <a href="https://clean-my-calanques.herokuapp.com/LoginRoute/auth/facebook" className="btnFb">
        <span className="fa fa-facebook"></span> Se connecter avec Facebook
        </a>

        <a className="linkRegister" onClick={redirect}>
            Créer un compte
                </a>

        </div>

        </div>
    )
}

export default Login;